import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Loader2, Scale } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthGoogle() {
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    if (!code) { navigate("/impostazioni"); return; }
    (async () => {
      try {
        await api.post("/auth/google/callback", { code, redirect_uri: window.location.origin + "/auth/google" });
        navigate("/impostazioni?connected=1");
      } catch {
        setError("Connessione a Google non riuscita. Riprova.");
        setTimeout(() => navigate("/impostazioni"), 2500);
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#f9f8f5]">
      <Scale className="w-8 h-8 text-[#C9A84C] mb-4" strokeWidth={1.5} />
      {error ? (
        <p className="text-[#9b2c2c]">{error}</p>
      ) : (
        <div className="flex items-center gap-3 text-[#1A2B4A]">
          <Loader2 className="w-5 h-5 animate-spin" /> Collegamento a Google Workspace…
        </div>
      )}
    </div>
  );
}
